import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientEnableBrightSyncMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { parseLegalClient } from 'api/helpers/legal/parseLegalClient';

export const useLegalClientEnableBrightSync = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientEnableBrightSyncMutation();

  const error = useError(apolloError);

  return {
    client: data?.legalClient ? parseLegalClient(data.legalClient) : undefined,
    loading,
    error,
    enableBrightSync: useCallback(
      async (id: string, versionNumber: number) => {
        const res = await handle({
          variables: { id, versionNumber },
        });
        return res.data?.legalClient
          ? parseLegalClient(res.data?.legalClient)
          : undefined;
      },
      [handle]
    ),
  };
};
